<template>
     <div class="pa-2" :style="{'--active-color': frontColor || '#0d8ddc'}">
    <swiper-wrapper v-if="rerender" ref="swiper" :loop="false" :real-index.sync="computedValue" :slides-per-view="3.6"
                    :space-between="0" swipe-to wrapper-class="category-slider">
      <div v-for="(item, i) in items" :key="i" :class="{'active-cat' : computedValue === i}"
           class="swiper-slide text-center" style="user-select: none" @click="getSwiper">
        <v-card class="d-flex align-center flex-column justify-center mx-auto rounded-lg" height="56"
                max-width="56" outlined width="100%" @click="computedValue = i">
          <v-img v-if="!!item.picture || !!item.icon || !!item.photoBackground"
                 :src="item.picture || item.icon || item.photoBackground" aspect-ratio="1" width="56"/>
          <v-icon v-else :color="computedValue === i ? 'white' : ''">mdi-account</v-icon>
        </v-card>
        <span class="mt-1 d-inline-block">
          {{ item.name || item.title }}
        </span>
      </div>
    </swiper-wrapper>

    <swiper-wrapper v-if="!!items && !!items.length" :loop="false" :space-between="10" class="mt-4"
                    slides-per-view="auto" wrapper-class="sub-category-slider">
      <div v-for="(item, i) in items[computedValue].children" :key="i"
           :class="{'active-cat white--text' : computedFilters.sub === (item.id || item.slug)}"
           class="swiper-slide text-center cursor-pointer" style="user-select: none; width: fit-content"
           @click="computedFilters.sub = computedFilters.sub === (item.id || item.slug) ? null : item.id || item.slug">
        <v-card class="py-1 px-3 rounded-lg" outlined>
          <img :alt="item.title || item.name" :src="item.icon || item.picture"
               style="width: 24px; aspect-ratio: 1; object-fit: contain"/>
          {{ item.name || item.title }}
        </v-card>
      </div>
    </swiper-wrapper>
  </div>
</template>

<script>
import SwiperWrapper from "@/view/pages/businessPage/components/cm/swiperWrapper";

export default {
  name: "mCategoryView",

  components: {SwiperWrapper},

  props: {
    value: Number,
    items: Array,
    frontColor: String,
    filters: Object
  },

  data: () => ({
    rerender: true,
  }),

  computed: {
    computedValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    computedFilters: {
      get() {
        return this.filters
      },
      set(val) {
        this.$emit('update:filters', val)
      }
    }
  },

  watch: {
    items: {
      deep: true,

      handler(val) {
        // this.forceRerender = Date.now();
        this.rerenderSwiper()
      }
    }
  },

  methods: {
    rerenderSwiper() {
      this.rerender = false
      this.$nextTick(() => {
        this.rerender = true
      })
    },
    getSwiper() {
      this.computedFilters = {
        sub: null
      }
      this.$refs.swiper.getSwiper();
    }
  }
}
</script>

<style scoped>
.active-cat >>> .v-card {
  background-color: var(--active-color);
  color: #fff;
}

.active-cat >>> span {
  color: var(--active-color);
}
</style>
